import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { NewsandeventsService } from 'src/app/newsandevents.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-website-landing-v2',
  templateUrl: './website-landing-v2.component.html',
  styleUrl: './website-landing-v2.component.scss'
})
export class WebsiteLandingV2Component implements OnInit, AfterViewInit {
  environment = environment;
  @ViewChild('mainvideo') mainvideo!: ElementRef<HTMLVideoElement>;
  subs: Subscription[] = [];
  changeP1Text: boolean = false;
  changeP2Text: boolean = false;
  changeP3Text: boolean = false;
  changeP4Text: boolean = false;
  
  imgindex: number = 0;

  pr = {
      description: '',
      date: '',
      text1: '',
      text2: '',
      link: ''
    };

    carousellinks = [
      '/productcategory/fttxpon',
      '/productcategory/catv',
      '/productcategory/ethernet',
      '/productcategory/fiberoptics',
      '/connectorprotector'
    ];
  private imgIntervalId: any;
  constructor(
    private titleService: Title,
    public _newsandeventsService: NewsandeventsService,
    // private sanitizer: DomSanitizer
    // public _tagService: TagService,
    // private cd: ChangeDetectorRef
    ) {
    this.titleService.setTitle('VeEX Inc. | The Verification EXperts');
    // this.loadImages();
  }
  //   ngAfterViewInit(): void {
  //   // Only load the Vimeo video after page is stable
  //   setTimeout(() => {
  //     this.vimeoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
  //       'https://player.vimeo.com/video/1094463737?h=ba380f932c&autoplay=1&muted=1&loop=1&background=1'
  //     );
  //     this.vimeoReady = true;
  //   }, 0);
  // }
ngAfterViewInit(): void {
  const video: HTMLVideoElement = this.mainvideo?.nativeElement;
  if (!video) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          video.muted = true;
          video.play().catch((err) => {
            console.warn('Autoplay was prevented:', err);
          });
          observer.disconnect();
        }
      },
      { threshold: 0 } // trigger as soon as it's visible
    );

    observer.observe(video);
  } else {
    // Fallback: just autoplay
    video.muted = true;
    video.play().catch((err) => {
      console.warn('Autoplay was prevented:', err);
    });
  }

  this.updateIMG();
}

updateIMG() {
  this.imgIntervalId = setInterval(() => {
    this.imgindex = (this.imgindex + 1) % this.carousellinks.length;
  }, 4750);
}

  ngOnInit(): void {
    if(this.pr.description == ''){
      this.subs.push(this._newsandeventsService.getprs().subscribe((data: any) => {
        // console.log(data.PressReleases);
        this.pr = data.PressReleases[0];
      }));
    }
    // console.log('landing component');
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
        sub.unsubscribe();
    });
    if (this.imgIntervalId) {
      clearInterval(this.imgIntervalId);
    }
  }
}
